import { Skill } from '@/mocks/skillsData';

export const cryptoskillMcpServersAData: Skill[] = [
  // ── 1inch AI ──
  {
    id: '1inch-ai-mcp',
    name: '1inch-ai',
    author: '1inch Network',
    authorHandle: '@1inch',
    tag: 'Skill',
    category: 'tools',
    description: '1inch AI MCP server. Access 1inch DEX aggregation, swap routing, limit orders, and DeFi analytics via Model Context Protocol.',
    downloads: 41200,
    stars: 1180,
    version: '1.2.0',
    installCommand: '> install the 1inch-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/1inch-ai',
    usageExample: '> swap via 1inch MCP\n> get best route\n> query liquidity',
    detailedDescription: '1inch AI MCP server providing access to the 1inch DEX aggregator via Model Context Protocol. Find optimal swap routes across 200+ liquidity sources, execute limit orders, and query DeFi analytics.',
    trending: true,
  },
  // ── AgentSeal MCP Scanner ──
  {
    id: 'agentseal-mcp-scanner',
    name: 'agentseal-mcp-scanner',
    author: 'AgentSeal',
    authorHandle: '@agentseal',
    tag: 'Skill',
    category: 'tools',
    description: 'AgentSeal MCP scanner. Security scanning for MCP servers — detect malicious tools, prompt injection risks, and unsafe server configurations.',
    downloads: 28400,
    stars: 820,
    version: '1.0.3',
    installCommand: '> install the agentseal-mcp-scanner skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/agentseal-mcp-scanner',
    usageExample: '> scan mcp server\n> detect prompt injection\n> audit tool safety',
    detailedDescription: 'AgentSeal MCP scanner providing security analysis for MCP server configurations. Detect malicious tool definitions, prompt injection vectors, unsafe permissions, and misconfigurations before deploying AI agents.',
  },
  // ── AiBTC Official MCP Server ──
  {
    id: 'aibtc-official-mcp-server',
    name: 'aibtc-official-mcp-server',
    author: 'AIBTC',
    authorHandle: '@aibtcdev',
    tag: 'Skill',
    category: 'tools',
    description: 'AiBTC official MCP server. Bitcoin AI agent toolkit via Model Context Protocol — BTC transactions, Stacks smart contracts, and on-chain analytics.',
    downloads: 33700,
    stars: 960,
    version: '1.1.0',
    installCommand: '> install the aibtc-official-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/aibtc-official-mcp-server',
    usageExample: '> query BTC data via MCP\n> interact with Stacks\n> get on-chain analytics',
    detailedDescription: 'Official AIBTC MCP server providing AI agent access to Bitcoin and Stacks ecosystem. Execute BTC transactions, interact with Clarity smart contracts, query Stacks DeFi protocols, and access Bitcoin L2 analytics.',
    featured: true,
  },
  // ── Alby NWC MCP ──
  {
    id: 'alby-nwc-mcp',
    name: 'alby-nwc-mcp',
    author: 'Alby',
    authorHandle: '@getAlby',
    tag: 'Skill',
    category: 'tools',
    description: 'Alby NWC MCP server. Nostr Wallet Connect integration via Model Context Protocol for Lightning payments and Bitcoin wallet operations.',
    downloads: 25600,
    stars: 740,
    version: '1.0.1',
    installCommand: '> install the alby-nwc-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/alby-nwc-mcp',
    usageExample: '> connect nostr wallet\n> send lightning payment\n> query wallet balance',
    detailedDescription: 'Alby Nostr Wallet Connect MCP integration enabling AI agents to interact with Lightning wallets via the NWC protocol. Send payments, query balances, create invoices, and manage Lightning channel operations.',
  },
  // ── Alchemy MCP ──
  {
    id: 'alchemy-mcp',
    name: 'alchemy-mcp',
    author: 'Alchemy',
    authorHandle: '@AlchemyPlatform',
    tag: 'Skill',
    category: 'analytics',
    description: 'Alchemy MCP server. Official Alchemy Web3 infrastructure access via Model Context Protocol — NFT APIs, token data, enhanced transactions, and webhooks.',
    downloads: 58900,
    stars: 1640,
    version: '2.0.0',
    installCommand: '> install the alchemy-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/alchemy-mcp',
    usageExample: '> query NFTs via Alchemy MCP\n> get token balances\n> fetch transaction history',
    detailedDescription: 'Official Alchemy MCP server exposing the complete Alchemy Web3 API suite through standardized MCP interfaces. Access NFT APIs, enhanced token data, historical transactions, mempool data, and webhook management.',
    featured: true,
  },
  // ── Alertio MCP ──
  {
    id: 'alertio-mcp',
    name: 'alertio-mcp',
    author: 'Alertio',
    authorHandle: '@alertio_dev',
    tag: 'Skill',
    category: 'analytics',
    description: 'Alertio MCP server. Real-time on-chain alert management via Model Context Protocol — price alerts, whale movements, smart contract events, and portfolio triggers.',
    downloads: 22100,
    stars: 640,
    version: '1.0.2',
    installCommand: '> install the alertio-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/alertio-mcp',
    usageExample: '> set price alert via MCP\n> monitor whale wallets\n> track contract events',
    detailedDescription: 'Alertio MCP server for real-time blockchain alert management. Create and manage price alerts, whale movement notifications, smart contract event triggers, and portfolio threshold alerts through standardized MCP interfaces.',
  },
  // ── Algorand MCP ──
  {
    id: 'algorand-mcp',
    name: 'algorand-mcp',
    author: 'Algorand Foundation',
    authorHandle: '@AlgoFoundation',
    tag: 'Skill',
    category: 'defi',
    description: 'Algorand MCP server. Official Algorand blockchain access via Model Context Protocol — ASA tokens, smart contracts, DeFi, and consensus data.',
    downloads: 31500,
    stars: 890,
    version: '1.3.0',
    installCommand: '> install the algorand-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/algorand-mcp',
    usageExample: '> query Algorand data\n> interact with ASA tokens\n> deploy smart contract',
    detailedDescription: 'Official Algorand MCP server providing full blockchain access via Model Context Protocol. Interact with ASA tokens, deploy and call smart contracts (PyTeal/AVM), query DeFi protocols, and access consensus participation data.',
  },
  // ── Alpaca MCP ──
  {
    id: 'alpaca-mcp',
    name: 'alpaca-mcp',
    author: 'Alpaca Markets',
    authorHandle: '@AlpacaHQ',
    tag: 'Skill',
    category: 'trading',
    description: 'Alpaca MCP server. Commission-free stock and crypto trading via Model Context Protocol — market orders, limit orders, portfolio management, and paper trading.',
    downloads: 44700,
    stars: 1280,
    version: '1.4.0',
    installCommand: '> install the alpaca-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/alpaca-mcp',
    usageExample: '> trade via Alpaca MCP\n> get portfolio positions\n> set stop loss',
    detailedDescription: 'Official Alpaca Markets MCP server enabling commission-free trading through AI agents. Execute market and limit orders, manage portfolio positions, access real-time quotes, and paper trade without risk.',
    trending: true,
  },
  // ── AptOracle ──
  {
    id: 'aptoracle',
    name: 'aptoracle',
    author: 'AptOracle',
    authorHandle: '@aptoracle',
    tag: 'Skill',
    category: 'defi',
    description: 'AptOracle price oracle for Aptos. Decentralized price feeds on Aptos blockchain with aggregated data from multiple DEX sources and off-chain providers.',
    downloads: 19800,
    stars: 570,
    version: '1.0.0',
    installCommand: '> install the aptoracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/aptoracle',
    usageExample: '> get Aptos token prices\n> query oracle feeds\n> access DEX aggregated data',
    detailedDescription: 'AptOracle decentralized price oracle for the Aptos blockchain. Aggregates price data from multiple Aptos DEXes and off-chain sources to provide reliable, manipulation-resistant price feeds for DeFi protocols.',
  },
  // ── Aptos MCP ──
  {
    id: 'aptos-mcp',
    name: 'aptos-mcp',
    author: 'Aptos Foundation',
    authorHandle: '@AptosLabs',
    tag: 'Skill',
    category: 'defi',
    description: 'Aptos MCP server. Official Aptos blockchain access via Model Context Protocol — Move smart contracts, NFTs, DeFi, and APT token operations.',
    downloads: 38600,
    stars: 1090,
    version: '1.5.0',
    installCommand: '> install the aptos-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/aptos-mcp',
    usageExample: '> deploy Move contract\n> query Aptos DeFi\n> transfer APT tokens',
    detailedDescription: 'Official Aptos MCP server providing comprehensive blockchain access via Model Context Protocol. Deploy and interact with Move smart contracts, manage NFT collections, access DeFi protocols, and execute APT/token transfers.',
    featured: true,
  },
  // ── Armor Crypto MCP ──
  {
    id: 'armor-crypto-mcp',
    name: 'armor-crypto-mcp',
    author: 'Armor Security',
    authorHandle: '@armor_crypto',
    tag: 'Skill',
    category: 'tools',
    description: 'Armor Crypto MCP server. Smart contract security analysis, rug-pull detection, and DeFi risk scoring via Model Context Protocol.',
    downloads: 26300,
    stars: 750,
    version: '1.1.0',
    installCommand: '> install the armor-crypto-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/armor-crypto-mcp',
    usageExample: '> audit contract via Armor\n> detect rug pull risk\n> score DeFi protocol',
    detailedDescription: 'Armor Crypto MCP security analysis server. Scan smart contracts for vulnerabilities, detect rug-pull patterns, score DeFi protocol risk, and verify audit status through standardized MCP interfaces.',
  },
  // ── AsterDex MCP Server ──
  {
    id: 'asterdex-mcp-server',
    name: 'asterdex-mcp-server',
    author: 'AsterDex',
    authorHandle: '@asterdex',
    tag: 'Skill',
    category: 'trading',
    description: 'AsterDex MCP server. Perp DEX trading on Sei network via Model Context Protocol — long/short positions, leverage trading, and funding rate management.',
    downloads: 24100,
    stars: 690,
    version: '1.0.4',
    installCommand: '> install the asterdex-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/asterdex-mcp-server',
    usageExample: '> trade perps on Sei\n> open long position\n> check funding rates',
    detailedDescription: 'AsterDex MCP server for perpetual futures trading on the Sei network. Open long/short positions, manage leverage, monitor funding rates, and access Sei-native liquidity through standardized MCP protocol.',
  },
  // ── Bankless Onchain MCP ──
  {
    id: 'bankless-onchain-mcp',
    name: 'bankless-onchain-mcp',
    author: 'Bankless',
    authorHandle: '@BanklessHQ',
    tag: 'Skill',
    category: 'analytics',
    description: 'Bankless onchain MCP server. Curated DeFi data access via Model Context Protocol — protocol analytics, token research, and on-chain investment intelligence.',
    downloads: 35200,
    stars: 1010,
    version: '1.2.0',
    installCommand: '> install the bankless-onchain-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/bankless-onchain-mcp',
    usageExample: '> query DeFi analytics\n> research tokens\n> get investment signals',
    detailedDescription: 'Bankless onchain MCP server delivering curated on-chain intelligence via Model Context Protocol. Access protocol TVL analytics, token fundamental research, whale wallet tracking, and DeFi investment signals.',
    trending: true,
  },
  // ── Base MCP ──
  {
    id: 'base-mcp',
    name: 'base-mcp',
    author: 'Base (Coinbase)',
    authorHandle: '@BuildOnBase',
    tag: 'Skill',
    category: 'defi',
    description: 'Base chain MCP server. Official Coinbase Base L2 access via Model Context Protocol — ETH/ERC-20 transfers, smart contracts, and Base DeFi protocols.',
    downloads: 67400,
    stars: 1920,
    version: '2.1.0',
    installCommand: '> install the base-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/base-mcp',
    usageExample: '> deploy on Base\n> bridge to Base\n> access Base DeFi',
    detailedDescription: 'Official Coinbase Base L2 MCP server. Deploy and interact with smart contracts on Base, bridge assets from Ethereum mainnet, access Base-native DeFi protocols (Aerodrome, Uniswap), and manage ERC-20 tokens.',
    featured: true,
  },
  // ── Bitcoin MCP ──
  {
    id: 'bitcoin-mcp',
    name: 'bitcoin-mcp',
    author: 'Bitcoin Community',
    authorHandle: '@bitcoin',
    tag: 'Skill',
    category: 'defi',
    description: 'Bitcoin MCP server. Native Bitcoin blockchain access via Model Context Protocol — UTXO queries, transaction building, mempool data, and PSBT signing.',
    downloads: 72100,
    stars: 2080,
    version: '1.6.0',
    installCommand: '> install the bitcoin-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/bitcoin-mcp',
    usageExample: '> query Bitcoin UTXO\n> build transaction\n> check mempool',
    detailedDescription: 'Native Bitcoin MCP server providing comprehensive blockchain access via Model Context Protocol. Query UTXOs, build and broadcast transactions, monitor the mempool, sign PSBTs, and access inscription/ordinals data.',
    featured: true,
    trending: true,
  },
  // ── Blockscout MCP ──
  {
    id: 'blockscout-mcp',
    name: 'blockscout-mcp',
    author: 'Blockscout',
    authorHandle: '@blockscoutcom',
    tag: 'Skill',
    category: 'analytics',
    description: 'Blockscout MCP server. Open-source blockchain explorer access via Model Context Protocol for multi-chain transaction analysis and contract verification.',
    downloads: 43800,
    stars: 1250,
    version: '1.3.0',
    installCommand: '> install the blockscout-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/blockscout-mcp',
    usageExample: '> query Blockscout data\n> verify contract\n> trace transaction',
    detailedDescription: 'Blockscout open-source blockchain explorer MCP server. Access transaction data, verify smart contracts, trace internal calls, and query token analytics across 30+ EVM-compatible networks.',
  },
  // ── BNBOracle ──
  {
    id: 'bnboracle',
    name: 'bnboracle',
    author: 'BNBOracle',
    authorHandle: '@bnboracle',
    tag: 'Skill',
    category: 'defi',
    description: 'BNBOracle decentralized price oracle. Real-time BNB Chain token price feeds aggregated from PancakeSwap, Venus, and other BSC DEX sources.',
    downloads: 21500,
    stars: 610,
    version: '1.0.1',
    installCommand: '> install the bnboracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/bnboracle',
    usageExample: '> get BSC token prices\n> query BNB oracle feeds\n> access DEX aggregated data',
    detailedDescription: 'BNBOracle decentralized price feed for BNB Smart Chain. Aggregates real-time prices from PancakeSwap, BiSwap, Venus, and other leading BSC protocols with outlier detection and TWAP calculations.',
  },
  // ── BNChain MCP Agent ──
  {
    id: 'bnchain-mcp-agent-ms',
    name: 'bnchain-mcp-agent',
    author: 'BNChain Community',
    authorHandle: '@bnchain_agent',
    tag: 'Skill',
    category: 'defi',
    description: 'BNChain MCP agent. AI agent wrapper for BNB Chain operations via Model Context Protocol with enhanced authentication and gas optimization.',
    downloads: 28900,
    stars: 830,
    version: '1.2.0',
    installCommand: '> install the bnchain-mcp-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/bnchain-mcp-agent',
    usageExample: '> setup BNChain agent\n> execute gas-optimized tx\n> authenticate agent ops',
    detailedDescription: 'BNChain MCP agent wrapper providing AI agent-native access to BNB Chain with enhanced authentication, gas optimization, and batched transaction support through standardized MCP interfaces.',
  },
  // ── Brian MCP ──
  {
    id: 'brian-mcp',
    name: 'brian-mcp',
    author: 'Brian AI',
    authorHandle: '@BrianknowsAI',
    tag: 'Skill',
    category: 'tools',
    description: 'Brian AI MCP server. Natural language DeFi transactions via Model Context Protocol — swap, bridge, stake, and lend using plain English commands.',
    downloads: 52300,
    stars: 1490,
    version: '1.8.0',
    installCommand: '> install the brian-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/brian-mcp',
    usageExample: '> swap 1 ETH for USDC\n> bridge 500 USDC to Arbitrum\n> stake ETH on Lido',
    detailedDescription: 'Brian AI MCP server enabling natural language DeFi operations. Translate plain English commands into on-chain transactions for swaps, bridges, staking, lending, and yield farming across 10+ networks.',
    featured: true,
    trending: true,
  },
  // ── CCXT MCP ──
  {
    id: 'ccxt-mcp',
    name: 'ccxt-mcp',
    author: 'CCXT',
    authorHandle: '@ccxt_official',
    tag: 'Skill',
    category: 'trading',
    description: 'CCXT MCP server. Unified crypto exchange access via Model Context Protocol — trade across 100+ exchanges with a single standardized interface.',
    downloads: 61700,
    stars: 1760,
    version: '3.0.0',
    installCommand: '> install the ccxt-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/ccxt-mcp',
    usageExample: '> trade on any exchange\n> query order book\n> fetch OHLCV data',
    detailedDescription: 'CCXT MCP server providing unified access to 100+ cryptocurrency exchanges through a single Model Context Protocol interface. Execute trades, query balances, fetch OHLCV data, and manage orders across all supported exchanges.',
    featured: true,
  },
  // ── Celo Official MCP ──
  {
    id: 'celo-official-mcp',
    name: 'celo-official-mcp',
    author: 'Celo Foundation',
    authorHandle: '@CeloOrg',
    tag: 'Skill',
    category: 'defi',
    description: 'Celo official MCP server. Celo mobile-first blockchain access via Model Context Protocol — CELO/cUSD/cEUR transfers, Mento DeFi, and staking.',
    downloads: 29400,
    stars: 840,
    version: '1.2.0',
    installCommand: '> install the celo-official-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/celo-official-mcp',
    usageExample: '> transfer cUSD via MCP\n> access Mento protocols\n> stake CELO',
    detailedDescription: 'Official Celo Foundation MCP server providing mobile-first blockchain access. Transfer CELO, cUSD, and cEUR stablecoins, interact with Mento DeFi protocols, manage staking, and access Celo governance.',
  },
  // ── Chainflip BaaS MCP ──
  {
    id: 'chainflip-baas-mcp',
    name: 'chainflip-baas-mcp',
    author: 'Chainflip',
    authorHandle: '@chainflip',
    tag: 'Skill',
    category: 'defi',
    description: 'Chainflip BaaS MCP server. Native cross-chain swaps via Model Context Protocol — swap BTC, ETH, and USDC across chains without wrapped tokens.',
    downloads: 33100,
    stars: 940,
    version: '1.1.0',
    installCommand: '> install the chainflip-baas-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/chainflip-baas-mcp',
    usageExample: '> swap BTC for ETH natively\n> cross-chain USDC transfer\n> query swap quote',
    detailedDescription: 'Chainflip Broker-as-a-Service MCP server enabling native cross-chain swaps without wrapped tokens. Swap BTC, ETH, DOT, and stablecoins directly through the Chainflip AMM protocol via standardized MCP interfaces.',
  },
  // ── Chainlink Feeds MCP ──
  {
    id: 'chainlink-feeds-mcp',
    name: 'chainlink-feeds-mcp',
    author: 'Chainlink Labs',
    authorHandle: '@chainlink',
    tag: 'Skill',
    category: 'analytics',
    description: 'Chainlink price feeds MCP server. Dedicated MCP interface for Chainlink oracle price feed data, data streams, and proof of reserve attestations.',
    downloads: 55600,
    stars: 1580,
    version: '2.2.0',
    installCommand: '> install the chainlink-feeds-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/chainlink-feeds-mcp',
    usageExample: '> get Chainlink price feed\n> query data streams\n> check PoR attestation',
    detailedDescription: 'Chainlink price feeds dedicated MCP server. Access real-time and historical price feeds across 1000+ data pairs, subscribe to data streams for low-latency updates, and verify Proof of Reserve attestations.',
  },
  // ── Chainstack Official RPC Nodes MCP ──
  {
    id: 'chainstack-official-rpc-nodes-mcp',
    name: 'chainstack-official-rpc-nodes-mcp',
    author: 'Chainstack',
    authorHandle: '@ChainstackHQ',
    tag: 'Skill',
    category: 'tools',
    description: 'Chainstack official RPC nodes MCP server. Enterprise-grade blockchain node access via Model Context Protocol across 25+ networks with SLA guarantees.',
    downloads: 47800,
    stars: 1360,
    version: '1.5.0',
    installCommand: '> install the chainstack-official-rpc-nodes-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/chainstack-official-rpc-nodes-mcp',
    usageExample: '> connect to Chainstack node\n> query any chain data\n> use dedicated RPC',
    detailedDescription: 'Official Chainstack enterprise RPC nodes MCP server. Access dedicated blockchain nodes across Ethereum, Solana, BNB Chain, Polygon, and 20+ other networks with 99.9% uptime SLA via standardized MCP interfaces.',
    featured: true,
  },
  // ── ChenSwap MCP ──
  {
    id: 'chenswap-mcp',
    name: 'chenswap-mcp',
    author: 'ChenSwap',
    authorHandle: '@chenswap',
    tag: 'Skill',
    category: 'defi',
    description: 'ChenSwap MCP server. Advanced AMM DEX with concentrated liquidity on BNB Chain via Model Context Protocol — swap, provide liquidity, and earn fees.',
    downloads: 17300,
    stars: 490,
    version: '1.0.0',
    installCommand: '> install the chenswap-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/chenswap-mcp',
    usageExample: '> swap on ChenSwap\n> add concentrated liquidity\n> claim LP fees',
    detailedDescription: 'ChenSwap MCP server for advanced AMM operations on BNB Chain. Execute concentrated liquidity swaps, provide liquidity with custom price ranges, claim accumulated trading fees, and monitor position health.',
  },
  // ── Claudy MCP Server ──
  {
    id: 'claudy-mcp-server',
    name: 'claudy-mcp-server',
    author: 'Claudy',
    authorHandle: '@claudy_ai',
    tag: 'Skill',
    category: 'tools',
    description: 'Claudy MCP server. Claude-powered crypto research agent via Model Context Protocol — automated market analysis, news summarization, and investment thesis generation.',
    downloads: 39500,
    stars: 1120,
    version: '1.3.0',
    installCommand: '> install the claudy-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/claudy-mcp-server',
    usageExample: '> research token with Claudy\n> summarize crypto news\n> generate investment thesis',
    detailedDescription: 'Claudy MCP server leveraging Claude AI for crypto market research. Automate token analysis, synthesize on-chain data with news, generate investment theses, and produce structured research reports via MCP interfaces.',
    trending: true,
  },
  // ── Claudy Research MCP ──
  {
    id: 'claudy-research-mcp',
    name: 'claudy-research-mcp',
    author: 'Claudy',
    authorHandle: '@claudy_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Claudy research MCP server. Deep crypto market research pipeline via Model Context Protocol — multi-source data aggregation and AI-powered analysis.',
    downloads: 31200,
    stars: 890,
    version: '1.1.0',
    installCommand: '> install the claudy-research-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/claudy-research-mcp',
    usageExample: '> deep research BTC\n> aggregate multi-source data\n> get AI analysis report',
    detailedDescription: 'Claudy research MCP server for comprehensive crypto market analysis. Aggregate data from on-chain sources, social media, news, and exchanges, then apply AI models to generate deep research reports.',
  },
  // ── Coinbase AgentKit Server ──
  {
    id: 'coinbase-agentkit-server',
    name: 'coinbase-agentkit-server',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Coinbase AgentKit MCP server. Full Coinbase AgentKit capabilities via Model Context Protocol — wallet management, token transfers, DeFi interactions, and NFT operations.',
    downloads: 64300,
    stars: 1840,
    version: '2.0.0',
    installCommand: '> install the coinbase-agentkit-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/coinbase-agentkit-server',
    usageExample: '> create wallet via AgentKit\n> execute DeFi action\n> mint NFT',
    detailedDescription: 'Official Coinbase AgentKit MCP server exposing the full AgentKit action framework via Model Context Protocol. Create wallets, execute token transfers, interact with DeFi protocols, deploy and mint NFTs programmatically.',
    featured: true,
    trending: true,
  },
  // ── Coinbase AgentKit ──
  {
    id: 'coinbase-agentkit',
    name: 'coinbase-agentkit',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Coinbase AgentKit core library. Modular toolkit for building crypto-native AI agents with wallet, trading, DeFi, and NFT capabilities.',
    downloads: 78200,
    stars: 2240,
    version: '2.1.0',
    installCommand: '> install the coinbase-agentkit skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/coinbase-agentkit',
    usageExample: '> build crypto agent\n> add DeFi capabilities\n> configure wallet actions',
    detailedDescription: 'Coinbase AgentKit core modular library for building fully autonomous crypto-native AI agents. Compose wallet management, ERC-20 operations, DeFi protocol interactions, and NFT capabilities into custom agent workflows.',
    featured: true,
  },
  // ── CoinGecko MCP Official ──
  {
    id: 'coingecko-mcp-official',
    name: 'coingecko-mcp-official',
    author: 'CoinGecko',
    authorHandle: '@coingecko',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinGecko official MCP server. Complete CoinGecko API access via Model Context Protocol — prices, market data, trending coins, and on-chain DEX analytics.',
    downloads: 89400,
    stars: 2560,
    version: '3.0.0',
    installCommand: '> install the coingecko-mcp-official skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/coingecko-mcp-official',
    usageExample: '> get coin price via CoinGecko\n> check trending tokens\n> query DEX analytics',
    detailedDescription: 'Official CoinGecko MCP server exposing the complete CoinGecko Pro API through standardized interfaces. Access real-time prices, market capitalization, trading volumes, trending coins, DEX pair analytics, and NFT market data.',
    featured: true,
    trending: true,
  },
  // ── CoinPaprika MCP ──
  {
    id: 'coinpaprika-mcp',
    name: 'coinpaprika-mcp',
    author: 'CoinPaprika',
    authorHandle: '@coinpaprika',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinPaprika MCP server. Crypto market intelligence via Model Context Protocol — fundamental data, ROI analytics, ICO history, and price predictions.',
    downloads: 32700,
    stars: 930,
    version: '1.2.0',
    installCommand: '> install the coinpaprika-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/coinpaprika-mcp',
    usageExample: '> get coin fundamentals\n> calculate ROI\n> query ICO history',
    detailedDescription: 'CoinPaprika MCP server providing deep crypto market intelligence. Access fundamental data, historical ROI analytics, ICO raise amounts, team and exchange information, and community metrics via standardized MCP interfaces.',
  },
  // ── CoinStats MCP ──
  {
    id: 'coinstats-mcp',
    name: 'coinstats-mcp',
    author: 'CoinStats',
    authorHandle: '@CoinStatsHQ',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinStats MCP server. Crypto portfolio tracking and market data via Model Context Protocol — wallet analytics, P&L tracking, and news aggregation.',
    downloads: 28100,
    stars: 800,
    version: '1.1.0',
    installCommand: '> install the coinstats-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/coinstats-mcp',
    usageExample: '> track portfolio via CoinStats\n> calculate P&L\n> aggregate crypto news',
    detailedDescription: 'CoinStats MCP server for portfolio tracking and market analytics. Connect multiple wallets and exchanges for unified P&L tracking, access aggregated news from 100+ sources, and monitor DeFi positions.',
  },
  // ── Crypto MCP Server ──
  {
    id: 'crypto-mcp-server',
    name: 'crypto-mcp-server',
    author: 'Crypto MCP Community',
    authorHandle: '@cryptomcp',
    tag: 'Skill',
    category: 'tools',
    description: 'Generic Crypto MCP server. Versatile crypto data aggregation via Model Context Protocol — multi-chain data, price feeds, and on-chain analytics in one server.',
    downloads: 36400,
    stars: 1040,
    version: '1.4.0',
    installCommand: '> install the crypto-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/crypto-mcp-server',
    usageExample: '> query any chain data\n> aggregate price feeds\n> multi-chain analytics',
    detailedDescription: 'Generic multi-purpose Crypto MCP server aggregating data from multiple chains and data providers. Access unified price feeds, on-chain analytics, wallet data, and DeFi metrics through a single standardized MCP interface.',
  },
  // ── CryptoOracle ──
  {
    id: 'cryptooracle',
    name: 'cryptooracle',
    author: 'CryptoOracle',
    authorHandle: '@cryptooracle_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'CryptoOracle MCP server. AI-powered price oracle combining on-chain feeds and predictive modeling via Model Context Protocol for DeFi integration.',
    downloads: 24800,
    stars: 710,
    version: '1.0.2',
    installCommand: '> install the cryptooracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/cryptooracle',
    usageExample: '> get oracle price\n> query predictive price\n> access DeFi-ready feed',
    detailedDescription: 'CryptoOracle MCP server combining traditional on-chain oracle feeds with AI predictive models. Access reliable price data for DeFi integration with anomaly detection, TWAP calculations, and forward-looking price estimates.',
  },
  // ── CryptoOracle2 ──
  {
    id: 'cryptooracle2',
    name: 'cryptooracle2',
    author: 'CryptoOracle',
    authorHandle: '@cryptooracle_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'CryptoOracle v2 MCP server. Enhanced oracle with multi-chain support, real-time deviation alerts, and cross-protocol price consensus via Model Context Protocol.',
    downloads: 21300,
    stars: 610,
    version: '2.0.0',
    installCommand: '> install the cryptooracle2 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/cryptooracle2',
    usageExample: '> get multi-chain oracle price\n> monitor price deviation\n> get consensus price',
    detailedDescription: 'CryptoOracle v2 MCP server with enhanced multi-chain oracle capabilities. Access aggregated price data across EVM chains and Solana, receive real-time deviation alerts, and get cross-protocol consensus prices.',
  },
  // ── deBridge MCP ──
  {
    id: 'debridge-mcp',
    name: 'debridge-mcp',
    author: 'deBridge',
    authorHandle: '@deBridgeFinance',
    tag: 'Skill',
    category: 'defi',
    description: 'deBridge MCP server. Cross-chain messaging and value transfer via Model Context Protocol — bridging, cross-chain swaps, and DLN order book access.',
    downloads: 41600,
    stars: 1190,
    version: '1.3.0',
    installCommand: '> install the debridge-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/debridge-mcp',
    usageExample: '> bridge assets via deBridge\n> cross-chain swap\n> access DLN order book',
    detailedDescription: 'deBridge MCP server for cross-chain messaging and asset transfers. Execute bridging operations, cross-chain swaps via the DLN order book, and build cross-chain DeFi workflows through standardized MCP protocol.',
    trending: true,
  },
  // ── DefiLlama MCP ──
  {
    id: 'defillama-mcp',
    name: 'defillama-mcp',
    author: 'DefiLlama',
    authorHandle: '@DefiLlama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama MCP server. Comprehensive DeFi TVL analytics via Model Context Protocol — protocol comparisons, yield tracking, liquidations, and treasury data.',
    downloads: 76800,
    stars: 2190,
    version: '2.0.0',
    installCommand: '> install the defillama-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/defillama-mcp',
    usageExample: '> get protocol TVL\n> compare DeFi yields\n> track liquidations',
    detailedDescription: 'Official DefiLlama MCP server providing comprehensive DeFi analytics. Access TVL for 4000+ protocols, compare yields across chains, track liquidation cascades, monitor treasury holdings, and analyze stablecoin flows.',
    featured: true,
    trending: true,
  },
  // ── DexPaprika MCP ──
  {
    id: 'dexpaprika-mcp',
    name: 'dexpaprika-mcp',
    author: 'DexPaprika',
    authorHandle: '@dexpaprika',
    tag: 'Skill',
    category: 'analytics',
    description: 'DexPaprika MCP server. DEX-focused market data via Model Context Protocol — pair analytics, liquidity tracking, price impact modeling, and volume metrics.',
    downloads: 27400,
    stars: 780,
    version: '1.1.0',
    installCommand: '> install the dexpaprika-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/dexpaprika-mcp',
    usageExample: '> query DEX pairs\n> analyze liquidity\n> model price impact',
    detailedDescription: 'DexPaprika MCP server specializing in DEX market analytics. Query trading pair data across major DEXes, analyze liquidity depth, model price impact for large orders, and track volume metrics across protocols.',
  },
  // ── DexScreener MCP ──
  {
    id: 'dexscreener-mcp',
    name: 'dexscreener-mcp',
    author: 'DexScreener',
    authorHandle: '@DexScreener',
    tag: 'Skill',
    category: 'analytics',
    description: 'DexScreener MCP server. Real-time DEX trading analytics via Model Context Protocol — pair charts, new token alerts, trending pairs, and rug detection.',
    downloads: 83200,
    stars: 2380,
    version: '2.0.0',
    installCommand: '> install the dexscreener-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/dexscreener-mcp',
    usageExample: '> get trending DEX pairs\n> monitor new tokens\n> check rug indicators',
    detailedDescription: 'DexScreener MCP server providing real-time DEX analytics. Monitor trending trading pairs, receive new token launch alerts, analyze price charts and volume patterns, and detect potential rug indicators across multi-chain DEXes.',
    featured: true,
    trending: true,
  },
  // ── Dexter MCP ──
  {
    id: 'dexter-mcp',
    name: 'dexter-mcp',
    author: 'Dexter Protocol',
    authorHandle: '@dexter_protocol',
    tag: 'Skill',
    category: 'defi',
    description: 'Dexter MCP server. Multi-chain DEX aggregator and liquidity optimizer via Model Context Protocol — smart routing, MEV protection, and gas estimation.',
    downloads: 23400,
    stars: 670,
    version: '1.0.3',
    installCommand: '> install the dexter-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/dexter-mcp',
    usageExample: '> get optimal swap route\n> enable MEV protection\n> estimate gas costs',
    detailedDescription: 'Dexter Protocol MCP server for multi-chain DEX aggregation. Find optimal swap routes with MEV protection, estimate gas costs across chains, and execute trades with slippage protection through standardized MCP interfaces.',
  },
  // ── Dune Analytics MCP ──
  {
    id: 'dune-analytics-mcp',
    name: 'dune-analytics-mcp',
    author: 'Dune Analytics',
    authorHandle: '@DuneAnalytics',
    tag: 'Skill',
    category: 'analytics',
    description: 'Dune Analytics MCP server. Official Dune data access via Model Context Protocol — execute SQL queries, retrieve dashboards, and subscribe to dataset updates.',
    downloads: 69300,
    stars: 1980,
    version: '2.1.0',
    installCommand: '> install the dune-analytics-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/dune-analytics-mcp',
    usageExample: '> run Dune query\n> get dashboard data\n> subscribe to dataset',
    detailedDescription: 'Official Dune Analytics MCP server. Execute custom SQL queries on Dune\'s blockchain database, retrieve existing dashboard visualizations, subscribe to scheduled dataset refreshes, and integrate on-chain analytics into AI workflows.',
    featured: true,
  },
  // ── EigenLayer MCP ──
  {
    id: 'eigenlayer-mcp',
    name: 'eigenlayer-mcp',
    author: 'EigenLayer',
    authorHandle: '@eigenlayer',
    tag: 'Skill',
    category: 'defi',
    description: 'EigenLayer MCP server. Restaking protocol access via Model Context Protocol — restake ETH, manage AVS delegations, and query restaking yields.',
    downloads: 47200,
    stars: 1350,
    version: '1.4.0',
    installCommand: '> install the eigenlayer-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/eigenlayer-mcp',
    usageExample: '> restake ETH on EigenLayer\n> delegate to AVS\n> check restaking yield',
    detailedDescription: 'Official EigenLayer MCP server for restaking operations. Restake native ETH or LSTs, delegate to Actively Validated Services (AVS), monitor restaking yields, and manage withdrawal queues through standardized MCP interfaces.',
    trending: true,
  },
  // ── EthOracle ──
  {
    id: 'ethoracle',
    name: 'ethoracle',
    author: 'EthOracle',
    authorHandle: '@ethoracle_dev',
    tag: 'Skill',
    category: 'analytics',
    description: 'EthOracle MCP server. Ethereum-focused price oracle with MEV and gas analytics via Model Context Protocol for DeFi protocol integration.',
    downloads: 26700,
    stars: 760,
    version: '1.1.0',
    installCommand: '> install the ethoracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/ethoracle',
    usageExample: '> get ETH price oracle\n> query gas analytics\n> access MEV data',
    detailedDescription: 'EthOracle MCP server providing Ethereum-specific oracle data including MEV analytics, gas price predictions, ETH/stETH peg monitoring, and DeFi liquidation threshold tracking via standardized MCP interfaces.',
  },
  // ── EVM Chains MCP Server ──
  {
    id: 'evm-chains-mcp-server',
    name: 'evm-chains-mcp-server',
    author: 'EVM Community',
    authorHandle: '@evm_chains',
    tag: 'Skill',
    category: 'defi',
    description: 'EVM Chains MCP server. Unified access to all major EVM-compatible chains via Model Context Protocol — Ethereum, Arbitrum, Optimism, Polygon, and 15+ more.',
    downloads: 53800,
    stars: 1540,
    version: '2.0.0',
    installCommand: '> install the evm-chains-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/evm-chains-mcp-server',
    usageExample: '> query any EVM chain\n> switch chain context\n> execute multi-chain tx',
    detailedDescription: 'Universal EVM chains MCP server providing seamless access to all major EVM-compatible networks. Switch chain context dynamically, execute cross-chain operations, and query data from Ethereum, Arbitrum, Optimism, Base, Polygon, and 15+ chains.',
    featured: true,
  },
  // ── EVM Copilot ──
  {
    id: 'evm-copilot',
    name: 'evm-copilot',
    author: 'EVM Copilot',
    authorHandle: '@evm_copilot',
    tag: 'Skill',
    category: 'tools',
    description: 'EVM Copilot MCP server. AI-assisted smart contract development and debugging via Model Context Protocol — code generation, gas optimization, and security checks.',
    downloads: 38900,
    stars: 1110,
    version: '1.3.0',
    installCommand: '> install the evm-copilot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/evm-copilot',
    usageExample: '> generate EVM contract\n> optimize gas usage\n> audit security issues',
    detailedDescription: 'EVM Copilot MCP server for AI-assisted smart contract development. Generate Solidity/Vyper code, optimize gas consumption, detect security vulnerabilities, simulate contract calls, and debug transaction failures.',
    trending: true,
  },
  // ── EVM MCP ──
  {
    id: 'evm-mcp',
    name: 'evm-mcp',
    author: 'EVM Community',
    authorHandle: '@evm_mcp',
    tag: 'Skill',
    category: 'defi',
    description: 'EVM MCP server. Core EVM blockchain operations via Model Context Protocol — read state, send transactions, call contracts, and monitor events.',
    downloads: 45600,
    stars: 1300,
    version: '1.5.0',
    installCommand: '> install the evm-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/evm-mcp',
    usageExample: '> read contract state\n> send EVM transaction\n> monitor events',
    detailedDescription: 'Core EVM MCP server for fundamental blockchain operations. Read contract state, encode and send transactions, call view functions, subscribe to event logs, and interact with any EVM-compatible blockchain.',
  },
  // ── Fernando MCP Agent ──
  {
    id: 'fernando-mcp-agent',
    name: 'fernando-mcp-agent',
    author: 'Fernando Labs',
    authorHandle: '@fernando_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'Fernando MCP agent. Autonomous DeFi agent framework via Model Context Protocol — strategy execution, portfolio rebalancing, and yield optimization automation.',
    downloads: 22800,
    stars: 650,
    version: '1.0.2',
    installCommand: '> install the fernando-mcp-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/fernando-mcp-agent',
    usageExample: '> setup DeFi strategy\n> automate rebalancing\n> optimize yield',
    detailedDescription: 'Fernando MCP autonomous DeFi agent framework. Define strategy parameters, automate portfolio rebalancing, execute yield optimization across protocols, and run condition-based DeFi workflows through MCP interfaces.',
  },
  // ── Flow Official MCP ──
  {
    id: 'flow-official-mcp',
    name: 'flow-official-mcp',
    author: 'Flow Foundation',
    authorHandle: '@flow_blockchain',
    tag: 'Skill',
    category: 'defi',
    description: 'Flow official MCP server. Flow blockchain access via Model Context Protocol — Cadence smart contracts, NFT marketplaces, and Flow token operations.',
    downloads: 31400,
    stars: 900,
    version: '1.3.0',
    installCommand: '> install the flow-official-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/flow-official-mcp',
    usageExample: '> deploy Cadence contract\n> trade Flow NFTs\n> transfer FLOW tokens',
    detailedDescription: 'Official Flow Foundation MCP server providing full blockchain access. Deploy and interact with Cadence smart contracts, trade on Flow NFT marketplaces (NBA Top Shot, NFL All Day), manage FLOW token operations and staking.',
  },
  // ── Foundry MCP ──
  {
    id: 'foundry-mcp',
    name: 'foundry-mcp',
    author: 'Paradigm',
    authorHandle: '@paradigm',
    tag: 'Skill',
    category: 'tools',
    description: 'Foundry MCP server. Ethereum development toolkit via Model Context Protocol — forge testing, cast transactions, anvil local chains, and chisel REPL.',
    downloads: 49800,
    stars: 1420,
    version: '1.4.0',
    installCommand: '> install the foundry-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/foundry-mcp',
    usageExample: '> run forge tests\n> cast contract call\n> spin up anvil fork',
    detailedDescription: 'Foundry Ethereum development toolkit MCP server. Run forge unit tests, execute cast transactions and contract calls, spin up anvil local blockchain forks, use chisel Solidity REPL, and automate smart contract testing pipelines.',
    featured: true,
  },
  // ── FourTrader MCP ──
  {
    id: 'fourtrader-mcp',
    name: 'fourtrader-mcp',
    author: 'FourTrader',
    authorHandle: '@fourtrader',
    tag: 'Skill',
    category: 'trading',
    description: 'FourTrader MCP server. Quantitative crypto trading via Model Context Protocol — backtesting, strategy deployment, and automated execution across exchanges.',
    downloads: 26100,
    stars: 750,
    version: '1.1.0',
    installCommand: '> install the fourtrader-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/fourtrader-mcp',
    usageExample: '> backtest strategy\n> deploy trading bot\n> execute automated trades',
    detailedDescription: 'FourTrader quant trading MCP server. Backtest trading strategies against historical data, deploy automated bots, execute orders across multiple exchanges simultaneously, and monitor performance metrics in real time.',
  },
  // ── Free Crypto News ──
  {
    id: 'free-crypto-news',
    name: 'free-crypto-news',
    author: 'CryptoNews Community',
    authorHandle: '@free_crypto_news',
    tag: 'Skill',
    category: 'analytics',
    description: 'Free Crypto News MCP server. Real-time crypto news aggregation via Model Context Protocol — 500+ sources, sentiment scoring, and breaking news alerts.',
    downloads: 43200,
    stars: 1230,
    version: '1.2.0',
    installCommand: '> install the free-crypto-news skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/free-crypto-news',
    usageExample: '> get latest crypto news\n> score news sentiment\n> set breaking news alert',
    detailedDescription: 'Free Crypto News MCP server aggregating real-time news from 500+ sources. Filter by asset, topic, or keyword, score article sentiment, detect market-moving news, and set automated alerts for breaking developments.',
    trending: true,
  },
  // ── FreqTrade MCP ──
  {
    id: 'freqtrade-mcp',
    name: 'freqtrade-mcp',
    author: 'Freqtrade',
    authorHandle: '@freqtrade',
    tag: 'Skill',
    category: 'trading',
    description: 'Freqtrade MCP server. Open-source crypto trading bot control via Model Context Protocol — strategy management, backtesting, and live trading operations.',
    downloads: 37600,
    stars: 1070,
    version: '1.5.0',
    installCommand: '> install the freqtrade-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/freqtrade-mcp',
    usageExample: '> start freqtrade bot\n> run backtest\n> check open trades',
    detailedDescription: 'Freqtrade open-source trading bot MCP server. Manage strategies, run backtests with historical data, control live trading operations, monitor open positions, and tune hyperparameters through standardized MCP interfaces.',
    featured: true,
  },
  // ── Funding Rates MCP ──
  {
    id: 'funding-rates-mcp',
    name: 'funding-rates-mcp',
    author: 'FundingRates',
    authorHandle: '@funding_rates',
    tag: 'Skill',
    category: 'analytics',
    description: 'Funding Rates MCP server. Real-time perpetual funding rate analytics via Model Context Protocol — cross-exchange comparison, historical data, and funding arbitrage signals.',
    downloads: 34800,
    stars: 990,
    version: '1.2.0',
    installCommand: '> install the funding-rates-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/funding-rates-mcp',
    usageExample: '> get funding rates\n> compare across exchanges\n> find arb opportunities',
    detailedDescription: 'Funding Rates MCP server for perpetual futures analytics. Compare real-time funding rates across Binance, Bybit, dYdX, Hyperliquid, and other exchanges, analyze historical patterns, and identify cash-and-carry arbitrage opportunities.',
  },
  // ── Gas Price MCP ──
  {
    id: 'gas-price-mcp',
    name: 'gas-price-mcp',
    author: 'GasNow',
    authorHandle: '@gasnow_eth',
    tag: 'Skill',
    category: 'tools',
    description: 'Gas Price MCP server. Real-time Ethereum gas analytics via Model Context Protocol — EIP-1559 base fee, priority fee, gas predictions, and cost estimation.',
    downloads: 51200,
    stars: 1460,
    version: '2.0.0',
    installCommand: '> install the gas-price-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/gas-price-mcp',
    usageExample: '> get current gas price\n> predict gas in 10min\n> estimate tx cost',
    detailedDescription: 'Gas Price MCP server for Ethereum gas analytics. Monitor real-time base fee and priority fee across EIP-1559 compatible networks, predict optimal submission timing, estimate transaction costs, and track historical gas trends.',
  },
  // ── Gitlawb ──
  {
    id: 'gitlawb',
    name: 'gitlawb',
    author: 'Gitlawb',
    authorHandle: '@gitlawb',
    tag: 'Skill',
    category: 'tools',
    description: 'Gitlawb MCP server. Blockchain legal and compliance document registry via Model Context Protocol — smart contract legal templates, DAO governance docs, and regulatory filings.',
    downloads: 14200,
    stars: 400,
    version: '1.0.0',
    installCommand: '> install the gitlawb skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/gitlawb',
    usageExample: '> get smart contract template\n> query DAO legal docs\n> check compliance filing',
    detailedDescription: 'Gitlawb MCP server for blockchain legal infrastructure. Access smart contract legal templates, DAO governance document repositories, regulatory compliance filings, and jurisdiction-specific crypto legal frameworks.',
  },
  // ── GOAT Onchain ──
  {
    id: 'goat-onchain',
    name: 'goat-onchain',
    author: 'GOAT',
    authorHandle: '@goat_sdk',
    tag: 'Skill',
    category: 'tools',
    description: 'GOAT onchain MCP server. Great Onchain Agent Toolkit via Model Context Protocol — modular plugin architecture for multi-chain DeFi agent operations.',
    downloads: 44300,
    stars: 1270,
    version: '1.3.0',
    installCommand: '> install the goat-onchain skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/goat-onchain',
    usageExample: '> use GOAT toolkit\n> compose DeFi actions\n> extend with plugins',
    detailedDescription: 'GOAT (Great Onchain Agent Toolkit) MCP server providing modular plugin architecture for AI agent DeFi operations. Compose wallet, trading, DeFi, and NFT plugins across multiple chains via standardized MCP interfaces.',
    trending: true,
  },
  // ── Hashlock MCP Server ──
  {
    id: 'hashlock-mcp-server',
    name: 'hashlock-mcp-server',
    author: 'Hashlock',
    authorHandle: '@hashlock_io',
    tag: 'Skill',
    category: 'tools',
    description: 'Hashlock MCP server. Comprehensive smart contract security platform via Model Context Protocol — audit reports, real-time scanning, and on-chain verification.',
    downloads: 33400,
    stars: 950,
    version: '1.2.0',
    installCommand: '> install the hashlock-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hashlock-mcp-server',
    usageExample: '> scan contract via Hashlock\n> get audit report\n> verify on-chain security',
    detailedDescription: 'Hashlock security platform MCP server providing comprehensive smart contract auditing. Access historical audit reports, run real-time vulnerability scans, verify on-chain security status, and monitor contract changes post-deployment.',
  },
];